// extracted by mini-css-extract-plugin
export default {"button":"RescheduleModalConfirmStage_button__kgW23","errors":"RescheduleModalConfirmStage_errors__QQ9RM"};